import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AOS from 'aos';
import { Provider } from "react-redux";
import store from "./store/index";
import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist';


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const persistor = persistStore(store);

AOS.init();
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
